'use strict';
const { getDependencyClass } = require('../../lib/dependencies.js');
const EMBED_REGEX = /<script.+?www\.tiktok\.com\/embed\.js.+?<\/script>/g;

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * TikTokEmbed
     *
     * This web component will lazy-load wrapped TikTok embeds. Once an
     * embed is scrolled into view, the TikTok embed script will be
     * added to the page, and following that, the embed will be upgraded.
     *
     * @example
     *   <phoenix-tiktok-embed src="https://www.tiktok.com/@username/video/123456789"></phoenix-tiktok-embed>`;
     */
    class TikTokEmbed extends pageClass.PhoenixElement {
        connectedCallback() {
            this.phxEmbedFallback = this.closest('phoenix-embed-fallback');
            this.canRender().then((canRender) => {
                if (canRender) {
                    this.observeFirstIntersection();
                } else {
                    this.phxEmbedFallback?.loadFallback?.();
                }
            });
        }

        onFirstIntersection() {
            this._appendTikTokBlockquote().then(this._loadScript);
        }

        _loadScript() {
            // Add the script tag for each instance of oEmbed response.
            return pageClass.util.addScriptResource('https://www.tiktok.com/embed.js');
        }

        async _appendTikTokBlockquote() {
            const url = this.getAttr('src', { required: true });
            const oUrl = `https://www.tiktok.com/oembed?url=${encodeURIComponent(url)}`;

            try {
                const response = await fetch(oUrl);
                if (!response.ok) throw Error(`failed to fetch ${oUrl}`);

                const data = await response.json();
                // Adding a script tag via innerHTML doesn't do anything so parse it out.
                this.innerHTML = data.html.replace(EMBED_REGEX, '');
            } catch (e) {
                this.innerHTML = '';
                this.phxEmbedFallback?.loadFallback?.();
            }
        }
    }
    window.customElements.define('phoenix-tiktok-embed', TikTokEmbed);
});
